import { progressionAtom } from '@teetsh/app/src/containers/Demarrage/atoms/progressionAtom';
import { DemarrageStep } from 'containers/Demarrage/types';
import { useAtom } from 'jotai/index';
import React, { useEffect, useState } from 'react';
import tw from 'twin.macro';

interface Props {
  value?: number;
  currentStep?: DemarrageStep;
}

export function DemarrageProgressBar({ value, currentStep }: Props) {
  const [storedProgression, setStoredProgression] = useAtom(progressionAtom);
  const [displayProgression, setDisplayProgression] =
    useState(storedProgression);
  useEffect(() => {
    if (value === undefined) return;

    // Start with the stored value (from previous page)
    setDisplayProgression(storedProgression);

    // Animate to the new value after a small delay
    const timeout = setTimeout(() => {
      setDisplayProgression(value);
      // Also update the stored value for next navigation
      setStoredProgression(value);
    }, 50);

    return () => clearTimeout(timeout);
  }, [currentStep, value, storedProgression, setStoredProgression]);

  return (
    <div tw="mt-6 w-full h-3 rounded-lg bg-brand-moderate">
      <div
        css={[
          tw`h-full rounded-lg bg-brand-intense transition-all duration-500 ease-out`,
          { width: `${displayProgression}%` },
        ]}
      />
    </div>
  );
}
